export { default } from "./SimpleEditableTable";
